import styled from "styled-components";

export const StyledRowSubComponent = styled.div`
    padding: 15px 30px;
`;
